import { default as base } from "./base";
import { default as darkBlue } from "./dark-blue";
import { default as darkPink } from "./dark-pink";
import { default as lightBlue } from "./light-blue";
import { default as lightPink } from "./light-pink";

export { base, lightBlue, darkBlue, lightPink, darkPink };
